var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-tags-list" },
    [
      _vm._l(_vm.tags, function (tag, index) {
        return _c("div", { staticClass: "c-tag" }, [
          _vm._v("\n        " + _vm._s(tag) + "\n        "),
          _c(
            "button",
            {
              staticClass: "tag-close",
              on: {
                click: function ($event) {
                  return _vm.removeTag(tag)
                },
              },
            },
            [_vm._v("x")]
          ),
        ])
      }),
      _vm._v(" "),
      _vm.tags.length
        ? _c(
            "button",
            { staticClass: "tags-list-clear", on: { click: _vm.clearAll } },
            [_vm._v("\n        Clear tags\n    ")]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }